import { Component, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import * as L from 'leaflet';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Component({
  selector: 'leaflet-maps',
  templateUrl: './leaflet-maps.component.html'
})
export class LeafLetMapsComponent {
    mapOpt: {};
    icon = L.icon({
        iconSize: [ 50, 51 ],
        iconAnchor: [ 25, 51 ],
        iconUrl: 'assets/shop-map-icon-blue.svg',
        shadowUrl: 'leaflet/marker-shadow.png'
    });
    iconCompetitor = L.icon({
        iconSize: [ 12, 12 ],
        iconAnchor: [ 6, 12 ],
        iconUrl: 'assets/svg-circle.svg',
    });

    compShopIcon = L.icon({
        iconSize: [ 50, 51 ],
        iconAnchor: [ 25, 51 ],
        iconUrl: 'assets/shop-map-icon-red.svg',
        shadowUrl: 'leaflet/marker-shadow.png'
    });
    ownShopIcon = L.icon({
        iconSize: [ 12, 12 ],
        iconAnchor: [ 6, 12 ],
        iconUrl: 'assets/svg-circle_blue.svg',
    });


    private isCompetitor: Boolean = false;
    
    private mapMarker: L.Marker = L.marker([null, null], {icon: this.icon}).bindPopup("Twoja placówka").openPopup();
    private _competitorsMarkers: Array<L.Marker> = [];
    
    map: L.Map;

    constructor(
        private http: HttpClient
    ) { 
    }

    private defaultOptions = {
        layers: [
          L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 25 }),
        ],
        zoom: 6,
        zoomControl: true,
        center: L.latLng([52.237049, 21.017532])
    };

    @Input()
    set ifComp(flag: Boolean) {
        this.isCompetitor = flag != null ? flag : this.isCompetitor;
        flag ? this.mapMarker.setIcon(this.compShopIcon) : null;
    }

    @Input() 
    set options(address: string) {
        this.getShopLocation(address);
        this.mapOpt = this.defaultOptions;
    }

    @Input()
    set shopsAddress(shopsAddresses: Array<string>) {
        this.removeCompMarkers();
        if(!shopsAddresses.length) return;
        shopsAddresses.map(address => 
            this.addressToGeo(address)
                .subscribe((location: {results}) => {
                    if(!location.results[0]) return;
                    const loc = location.results[0].geometry.location;
                    const icon = this.isCompetitor ? this.ownShopIcon : this.iconCompetitor;
                    this._competitorsMarkers.push(L.marker([loc.lat, loc.lng], {icon: icon})) 
                    this._competitorsMarkers.map(marker => {
                        marker.addTo(this.map)
                    });
                })
        )
    }

    private removeCompMarkers(): void {
        // delete before adding new
        this._competitorsMarkers.map(marker => marker.removeFrom(this.map));
        this._competitorsMarkers = [];
    }

    addressToGeo(address: string): Observable<{}> {
        return this.http.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=AIzaSyALu5Vrm4zFRUsOlG8wFa35XQCDMvnfQNg`)
    }

    // adding main shop to add
    getShopLocation(address: string): void{
        if(!address) return;
        this.addressToGeo(address)
          .subscribe((location: {results}) => {
            if(!location.results[0]) return;
            const loc = location.results[0].geometry.location;
            this.map.setZoom(15);
            this.map.panTo(new L.LatLng(loc.lat, loc.lng));
            this.mapMarker.setLatLng([loc.lat, loc.lng]);
            this.mapMarker.addTo(this.map);            
          });
    }

    onMapReady(map: L.Map) {
        // const marker = L.marker([52.237049, 21.017532], {icon: this.icon});
        // marker.addTo(map);
        this.map = map;
        setTimeout(() => {this.map.invalidateSize()});
    }

}
